import React, { Component } from "react";
// Assets
import { RiFacebookFill, RiDiscordFill } from "react-icons/ri";
import { AiFillInstagram, AiFillYoutube } from "react-icons/ai";
import { FaTelegramPlane, FaTwitch } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { Link } from "react-router-dom";
import loco from "../../..//images/games/loco.png";
import SocialMediaIcons from "../../common/SocialMediaIcons";
import OrgIcon from "../../../images/icon/orgIcon";

export default class MicroWebSiteContactUs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      microWebSiteData: props.microWebSiteData,
      backgroundColors: props.backgroundColors,
      secondaryTextColors: props.secondaryTextColors,
      background: props.background,
      secondary: props.secondary,
    };
  }

  render() {
    return (
      <div>
        {/* Official site details */}
        <div className="d-flex justify-content-center mb-10" style={{ marginTop: "60px" }}>
          {this.state.microWebSiteData?.logo?.url ? (
             <img
               src={this.state.microWebSiteData.logo?.url}
               alt={""}
               className="border border-2 border-white rounded-10"
               style={{ width: "100px", height: "100px", objectFit: "contain" }}
             />
           ) : (
             <OrgIcon width="100px" height="100px" className="border border-2 text-white rounded-10" />
           )}
        </div>
        {/* Social media contacts */}
        <SocialMediaIcons
          socialMediaData={this.state.microWebSiteData?.contactDetails}
          backgroundColor={this.state.secondary}
          textColor={this.state.background}
        />
      </div>
    );
  }
}
